require('public/css/catalog.scss');
const {
	prepareCatalog,
} = require('public/js/catalog-helper');

var THE_SCRIPT = function () {
	const $onReady = require('./lib/on-ready');

	$onReady({
		rp$, window,
		label: 'catalog',
		fn: function () {
			loadCatalogs();
		},
	});

	function loadCatalogs() {
		prepareCatalog();
	}
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
